import moment from 'moment';
import _ from 'lodash';

export const toSelect = list =>
  list.map(item => ({ label: item.name, value: item.id }));

export const calculateGradeAge = (birthdate) => {
  const date = moment(birthdate);
  const limitDate = moment({
    year: date.year(),
    month: 3,
    day: 30
  });
  let years = moment().year() - date.year();
  const isAfterLimitDate = date.isSameOrAfter(limitDate);
  if (isAfterLimitDate) {
    years -= 1;
  }
  return years;
};

export const findCycleAndGrade = (years, cycles) => {
  let cycleId;
  let gradeId;
  cycles.forEach((cycle) => {
    cycle.grades.forEach((grade) => {
      if (grade.age === years) {
        cycleId = cycle.id;
        gradeId = grade.id;
      }
    });
  });
  return { cycleId, gradeId };
};

export const isAdministrator = ({ type }) =>
  type === 'Administrator';

export const applyQueryParams = (url, params) => {
  let urlWithQuery = url;
  const validParams = params.filter(param => Boolean(param.value));
  if (!_.isEmpty(validParams)) {
    const first = validParams.shift();
    urlWithQuery = `${urlWithQuery}?${first.prop}=${first.value}`;
    validParams.forEach(({ prop, value }) => {
      urlWithQuery = `${urlWithQuery}&${prop}=${value}`;
    });
  }
  return urlWithQuery;
};

export const studentPermission = (user) => {
  if (user.type === 'Administrator') {
    return true;
  } else if (user.type === 'Director') {
    return true
    // return user.cycleId === student.grade.cycle.id;
  } else if (user.type === 'Teacher') {
    // Not implemented yet
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js